export const fr = {
  title: `Loisirs et activités physique`,
  p1: `Est-ce que je peux faire de l’activité physique/loisir?`,
  p2: `Il est important de comprendre que l’activité physique est généralement recommandée pour tous. De même que l’activité physique démontre un effet positif sur le contrôle des crises. Toutefois, lorsque nous faisons face à diverses maladies dont l’épilepsie, chaque personne détient des besoins d’adaptations différents avec certains sports. En effet, étant donné qu’une crise d’épilepsie peut survenir à n’importe quel moment, il faut prendre des précautions préventives afin d’éviter toute blessure ou accident potentiels.`,
  bestSport: {
    p1: `Un facteur déterminant lors de la sélection d’un sport/loisir est l’intensité et la fréquence des épisodes de crise. Les sports les plus sécuritaires pour une personne vivant avec de l’épilepsie sont:`,
    bullets: [
      `Athlétisme`,
      `Golf`,
      `Danse`,
      `Sports de raquette: tennis, badminton, ping-pong`,
      `Ski de fond`,
      `Basketball`,
      `Volleyball`,
      `Marche`,
      `Course à pied`
    ],
    p2: `Malgré que ces activités soient sécuritaires, ceux-ci le sont davantage avec une surveillance à proximité. De plus, en prenant des mesures préventives comme le port du casque, équipement de sécurité, ou même gilet de sauvetage en cas de nage, est fortement recommandé.`
  },
  notRecommendedSports: {
    p1: `Activité moins recommandée: `,
    bullets: [
      `Escalade`,
      `Ski alpin`,
      `Plongée sous-marine`,
      `Natation`,
      `Parachutisme`,
      {
        text: `Sport de contact: `,
        bullets: [`Football`, `Hockey`, `Soccer`, `Boxe`]
      }
    ],
    p2: `Il est recommandé de parler à son médecin avant d’exercer ces sports, afin d’obtenir un meilleur portrait de la maladie du patient, et ses limitations possibles.`
  }
};
